import moment from 'moment';
import { ReactComponent as EditIcon } from '../../../assets/images/pencil.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close-circle.svg';
import { ChecklistInterface } from '../../../utils/types/checklist';
import { MRT_ColumnDef } from 'material-react-table';
import IconButton from '@mui/material/IconButton';
import { UserInterface } from '../../../utils/types/user';

const getChecklistGridColumns = (
  onEditChecklist: (checklist: ChecklistInterface) => void,
  onDeleteChecklist: (checklist: ChecklistInterface) => void
): Array<MRT_ColumnDef<ChecklistInterface>> => [
    {
      accessorKey: 'createdAt',
      header: 'Created at',
      Cell: ({ cell }) => {
        const date = new Date(cell.getValue<string>());
        const humanReadableDate = moment(date).fromNow();

        return <span style={{ color: '#52659B', fontWeight: 500 }}>{humanReadableDate}</span>;
      }
    },
    {
      accessorKey: 'name',
      header: 'Name'
    },
    {
      accessorKey: 'creator',
      header: 'Created by',
      Cell: ({ cell }) => {
        const creator = cell.getValue<UserInterface>();

        return (
          <span>
            {creator ? creator.name + ' ' + creator.lastName : ''}
          </span>
        );
      }
    },
    {
      header: 'Actions',
      enableSorting: false,
      Cell: ({ cell }) => (
        <>
          <IconButton
            color="secondary"
            aria-label="Edit"
            onClick={() => onEditChecklist(cell.row.original)}
          >
            <EditIcon />
          </IconButton>

          <IconButton
            color="secondary"
            aria-label="Delete"
            onClick={() => onDeleteChecklist(cell.row.original)}
          >
            <CloseIcon />
          </IconButton>
        </>
      )
    },
  ];

export default getChecklistGridColumns;
